import React from 'react';
import classNames from 'classnames/bind';
import { SearchField } from '@carnica/ui-kit';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { INPUT_PLACEHOLDER_TEXT } from "../../utils/constants";
import { useInputQuery } from "./hooks/useInputQuery";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Input = function Input(_ref) {
  var onSearch = _ref.onSearch,
    onChange = _ref.onChange,
    withIndent = _ref.withIndent;
  var _useInputQuery = useInputQuery({
      onSearch: onSearch,
      onChange: onChange
    }),
    query = _useInputQuery.query,
    ref = _useInputQuery.ref,
    handleChange = _useInputQuery.handleChange,
    handleClear = _useInputQuery.handleClear,
    handleKeyDown = _useInputQuery.handleKeyDown,
    handleBeforeInput = _useInputQuery.handleBeforeInput;
  return /*#__PURE__*/React.createElement(SearchField, {
    autoFocus: true,
    className: cx('input', {
      'input--indent': withIndent
    }, cnComponentsTheme('dark')),
    inputRef: ref
    // @ts-expect-error FIXME: common input types
    ,
    onBeforeInput: handleBeforeInput,
    onChange: handleChange,
    onClear: handleClear,
    onKeyDown: handleKeyDown,
    placeholder: INPUT_PLACEHOLDER_TEXT,
    spellCheck: false,
    value: query,
    "data-t-id": "blocks-SearchControl"
  });
};